import { RelatedLP } from '../../../related/RelatedPages';
export default function Page() { return <RelatedLP slug="queens-butler" locale="en" />; }
